import { render, staticRenderFns } from "./DialogIndexAlert.vue?vue&type=template&id=621b3c84&scoped=true&lang=pug"
import script from "./DialogIndexAlert.vue?vue&type=script&lang=js"
export * from "./DialogIndexAlert.vue?vue&type=script&lang=js"
import style0 from "./DialogIndexAlert.vue?vue&type=style&index=0&id=621b3c84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621b3c84",
  null
  
)

export default component.exports